<template>
  <div class="tab">
    <h3>中国儿童青少年积极发展调查及促进研究（CPYDS）</h3>
    <div>
        <p>积极青少年发展视角是近年来发展心理学领域理论与实证研究范式的一个重大转变，它源于对“缺陷”和“病理”视角的批评而提出，指出“无问题并非是对青少年发展所做的最好准备”，强调应关注个体充分、繁荣的发展而不是仅仅减少问题行为。该视角认为所有青少年都有积极成长与发展的潜在能力，应该聚焦在儿童青少年发展轨迹的积极方面并强调人类发展中潜在的可塑性及青少年是其自身发展的潜在资源。以往研究更多聚焦于儿童青少年问题，关注消极结果和危险性因素，而忽略了诸如自身能力、坚毅、乐观、感恩、奉献、自律等积极结果和保护性因素的探讨。并且已有相关研究均来自西方及港澳地区，而国内尚缺乏系统地探索儿童青少年积极发展的研究。</p>
        <p>中国儿童青少年积极发展调查及促进研究（China Positive Youth Development Studies,简称：CPYDS）是在北京师范大学心理学部林丹华教授于2015年获批的国家社会科学重大项目“流动背景下处境不利儿童青少年发展数据库建设及积极发展体系研究”（15ZDB138）下进行实施的，旨在通过多水平、多维度的全国多地区代表性调查和追踪研究，系统了解中国文化下儿童青少年（积极）发展的理论框架和关键指标体系，发现可被干预与改变的关键性的个体与环境促进性因素，勾勒出中国儿童青少年积极发展的特点、轨迹与路径，并开发科学、有效的儿童青少年积极发展预防与促进方案，助力我国儿童青少年的最优化和“繁荣”（thriving）发展。</p>
        <p>CPYDS以我国流动儿童、留守儿童、城市普通儿童以及农村普通儿童为重点关注对象，深入探讨与其心理和生理健康发展密切相关的研究主题，目前已完成覆盖全国10个省市的20个区县的中小学生发展状况的基线调查和3次追踪调查。</p>
        <p>CPYDS是国内第一个全面、深入地从积极发展的视角开展流动背景下处境不利儿童青少年积极发展的研究。研究结果将极大地推动并促进包括处境不利儿童在内的我国儿童青少年的发展，为研究人员提供科学严谨的数据支持与指导，为教育实践工作者提供行之有效的预防与促进方案及活动指南，为政府部门提供政策制定依据，真正实现“让每个孩子成为有用之才”之国家战略目标。</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'framework',
  data () {
    return {}
  }
}
</script>
<style scoped src="../../assets/style/grandchild.css">
  /* @import '../assets/style/child.css'; */
</style>



// WEBPACK FOOTER //
// src/components/tabs/framework.vue